import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import ErrorScreen from './component'
import Overlay from '../../Atoms/Overlay'

class ErrorContainer extends PureComponent {
  render () {
    return (
      <Overlay>
        <ErrorScreen
          error={this.props.error}
          notRetryable={this.props.notRetryable}
        />
      </Overlay>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    error: state.error.error,
    notRetryable: state.error.notRetryable
  }
}

export default connect(mapStateToProps, null)(ErrorContainer)
